module.exports = __webpack_public_path__ + "static/img/海报设计-3D海报.f7d16e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10001/海报设计-3D海报.png
// module id = 7LkJ
// module chunks = 1